export const formatMultipleSelectData = (options: SelectOption[]) => {
  return options ? options.map((c: SelectOption) => c.key).flat() : []
}
